import { UseResponsiveBreakpoints } from '@leverege/molten/views';
import MapKeyMobile from './MapKeyMobile';
import MapKeyDesktop from './MapKeyDesktop';
const components = {
  small: MapKeyMobile,
  big: MapKeyDesktop
};
export default function MapKeyResponsive(props) {
  return UseResponsiveBreakpoints(components, props);
}